<template>
  <div class="flex flex-wrap mb-2">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6" style="position:relative">
      <div class="grid grid-cols-12">
        <span>動態預算</span>
        <div class="col-span-10 text-sm leading-6 text-gray-400">開啟時，系統將自動根據每階段成效，動態調配總預算比例</div>
        <div>
          <InputSwitch :disabled="editPageType" v-model="viewDatalistData.useDynamicBudget" class="float-right"/>
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
  </div>
</template>
<script>
  import InputSwitch from 'primevue/inputswitch';

  export default {
    name: 'StageDynamicBudget',
    props: {
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      lang: {
        type: Object
      },
    },
    components: {
      InputSwitch
    },
    data() {
      return {
        useDynBudget: false
      }
    },
    created() {

    },
    watch:{
      'viewDatalistData.useDynamicBudget':function(v){
        console.log('viewDatalistData.useDynamicBudget');
        console.log(v);
      },
    },
    methods: {

    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep(.calendar-group) {
    .p-calendar .p-inputtext {
      padding: 0.25rem;
      border: 0px;
    }
  }
</style>